module.exports = __webpack_public_path__ + "static/img/8.19fdd71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/8/1/4/eng/8.png
// module id = il10
// module chunks = 0